import { jsx as _jsx } from "react/jsx-runtime";
import { SvgIcon } from '@mui/material';
import { HelixPalette } from '../../../helix';
export const ITick = ({ color = HelixPalette.neutral90, dataId, size = 24, style }) => {
    return (_jsx(SvgIcon, Object.assign({ "data-id": dataId, htmlColor: color, sx: Object.assign({ fontSize: size }, style) }, { children: _jsx("path", { d: "M8.99973 15.8879L19.4995 4.9996L20.9995 6.5556L9 19.0004L3 12.7774L4.5 11.2224L8.99973 15.8879Z" }) })));
};
export default ITick;
